'use strict';

$('body').on('click', '.togglePassword', function () {
    $(this).toggleClass('icon-eye-hide-show-password icon-eye-slash');
    const password = $(this).closest('.password-container, .password-form').find('.password');
    const type = password.attr('type') === 'password' ? 'text' : 'password';
    password.attr('type', type);
});
